var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.01018 6L10 0.863219L9.14172 0L4.99002 4.27397L0.838324 0L0 0.863219L4.98982 6H5.01018Z","fill":"#F752AD"}));
}

ArrowDown.defaultProps = {"width":"10","height":"6","viewBox":"0 0 10 6","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
